import { render, staticRenderFns } from "./GatewayCommand.vue?vue&type=template&id=4828d12c&scoped=true"
import script from "./GatewayCommand.vue?vue&type=script&lang=js"
export * from "./GatewayCommand.vue?vue&type=script&lang=js"
import style0 from "./GatewayCommand.vue?vue&type=style&index=0&id=4828d12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828d12c",
  null
  
)

export default component.exports